import { useQuery as s } from "@tanstack/react-query";
import { getTrailerRentalPrice as n } from "../requests/getTrailerRentalPrice.js";
const u = ({ locationId: e, typeId: r, pickupTime: t, returnTime: a }) => s({
  queryKey: ["trailer-rental-price", e, r, t, a],
  queryFn: async () => await n({
    locationId: e,
    typeId: r,
    pickupTime: t,
    returnTime: a
  }),
  enabled: !1,
  retry: !0,
  staleTime: 6e4
});
export {
  u as useGetTrailerRentalPrice
};
